module.exports = __webpack_public_path__ + "static/img/scene_pic3.ce5e195.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/scene_pic3.png
// module id = IK2Z
// module chunks = 1